import { noop } from "lodash"
import PropTypes from "prop-types"
import PeriodSelector from "components/period-selector"
import { DATE, PERIOD, PERIOD_SELECTOR_LABELS } from "helpers/shapes"
import { DATA_STATUSES } from "helpers/data-statuses"

export default function CompareDateSelector({ period,
  earliestDate,
  latestDate,
  startDate,
  endDate,
  datesAdjusted,
  unmodeledDates = [],
  onChange = noop,
  handleResetOption = null,
  customizeOptions = null,
  isIntradayEnabled = false,
  isIntradayBatchAvailable = false,
  isEndDateToday = false,
  intradayAsOf = null,
  intradayBatchStatus = null,
  skipAutoAdjustment = false,
  datesWithLabels = false,
  labels,
  tooltipContent,
}) {
  return <PeriodSelector {...{
    earliestDate,
    latestDate,
    endDate,
    startDate,
    periodAdjusted: datesAdjusted,
    unmodeledDates,
    period,
    onChange,
    handleResetOption,
    customizeOptions,
    isIntradayEnabled,
    isIntradayBatchAvailable,
    isEndDateToday,
    intradayAsOf,
    intradayBatchStatus,
    skipAutoAdjustment,
    datesWithLabels,
    labels,
    tooltipContent,
  }}
  />
}

CompareDateSelector.propTypes = {
  period: PERIOD.isRequired,
  earliestDate: DATE.isRequired,
  latestDate: DATE.isRequired,
  startDate: DATE.isRequired,
  endDate: DATE.isRequired,
  datesAdjusted: PropTypes.bool.isRequired,
  unmodeledDates: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
  handleResetOption: PropTypes.func,
  customizeOptions: PropTypes.func,
  isIntradayEnabled: PropTypes.bool,
  isIntradayBatchAvailable: PropTypes.bool,
  isEndDateToday: PropTypes.bool,
  intradayAsOf: PropTypes.string,
  intradayBatchStatus: PropTypes.oneOf(DATA_STATUSES),
  skipAutoAdjustment: PropTypes.bool,
  datesWithLabels: PropTypes.bool,
  labels: PERIOD_SELECTOR_LABELS,
  tooltipContent: PropTypes.string,
}
